import { api } from "./api";
import { URL } from '../utils/constant'

export const getIdeas = () => {
    return api.get(URL.ideasReview)
}

export const getJuryDetailsAdmin = () => api.get(URL.juryDetailsAdmin);

export const getDashboardData = () => api.get(URL.dashboard);

export const getAdminUsers = () => api.get(URL.adminUsers);

export const getAdminUsersById = (id) => api.get(`${URL.adminUsers}/${id}`);

export const getJuryDetailsAdminById = (id) => api.get(`${URL.juryDetailsAdmin}/${id}`);


export const updateJuryDetailsAdmin = (id, name, email, designation, department, category, implementArea, linkedin, twitter, facebook, about, isActive) => api.post(URL.updateJuryDetailsAdmin, JSON.stringify({
    juryId: id,
    name: name,
    email: email,
    designation: designation,
    department: department,
    category: category,
    implementArea: implementArea,
    linkedin: linkedin,
    twitter: twitter,
    facebook: facebook,
    about: about,
    isActive: isActive
}), {
    headers: {
        "content-type": "application/json"
    }
});
export const createJuryProfile = (name, email, designation, department, category, implementArea, linkedin, twitter, facebook, about, isActive) => api.post(URL.createJuryProfile, JSON.stringify({
    name: name,
    email: email,
    designation: designation,
    department: department,
    category: category,
    implementArea: implementArea,
    linkedin: linkedin,
    twitter: twitter,
    facebook: facebook,
    about: about,
    isActive: isActive
}), {
    headers: {
        "content-type": "application/json"
    }
});

export const createAdminUser = (name, email, phone, empType, isActive) => api.post(URL.createAdminUser, JSON.stringify({
    name: name,
    email: email,
    phone: phone,
    empType: empType,
    isActive: isActive
}), {
    headers: {
        "content-type": "application/json"
    }
});


export const editAdminUser = (id,name, email, phone, empType, isActive) => api.post(URL.editAdminUser, JSON.stringify({
    userId: id,
    name: name,
    email: email,
    phone: phone,
    empType: empType,
    isActive: isActive
}), {
    headers: {
        "content-type": "application/json"
    }
});




